import { styled, Typography } from '@mui/material';

export const ContainerW = styled('div')`
  margin-bottom: 4px;
`;

export const SectionLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 8px;
`;

export const SquareImagesRow = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
  }
`;

export const SquareThumbnail = styled('div')<{ size: string }>`
  flex-shrink: 0;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 8px;
`;
